import { cleanFlashcardText } from "./flashcardText";

const trimSentence = (text) => {
  const cleaned = String(text || "").replace(/\s+/g, " ").trim();
  if (!cleaned) return "";
  return cleaned.length > 140 ? `${cleaned.slice(0, 137)}…` : cleaned;
};

const hasLatexDelimiters = (value) =>
  /(\$\$|\\\[|\\\(|\$)/.test(String(value || ""));

const wrapLatexBlock = (latex) => {
  const trimmed = String(latex || "").trim();
  if (!trimmed) return "";
  if (hasLatexDelimiters(trimmed)) return trimmed;
  return `$$${trimmed}$$`;
};

const formatProblemContext = (problem) => {
  const latex = String(problem?.latex || "").trim();
  if (latex) return wrapLatexBlock(latex);

  const raw =
    problem?.problemText || problem?.statement || problem?.rawProblem || "";
  return trimSentence(raw);
};

const formatFront = (label, context, fallback) => {
  if (context) return `${label}\n${context}`;
  return fallback ? `${label}\n${fallback}` : label;
};

export const buildFlashcardSuggestions = (problem) => {
  if (!problem) return [];
  const suggestions = [];
  const method =
    problem.approach ||
    problem.planMethodGuess ||
    problem.problemType ||
    "";
  const why =
    problem.planWhy ||
    problem.whyApproach ||
    problem.whyType ||
    "";
  const planText = problem.planText || "";
  const whyText = why || planText;
  const trap =
    (Array.isArray(problem.mistakeTags) && problem.mistakeTags[0]) ||
    problem.planDontKnowReason ||
    "";
  const context = formatProblemContext(problem);
  const methodText = trimSentence(cleanFlashcardText(method));
  const whyShort = trimSentence(cleanFlashcardText(whyText));
  const trapShort = trimSentence(cleanFlashcardText(trap));

  if (methodText) {
    suggestions.push({
      id: "method-choice",
      type: "method_choice",
      front: formatFront(
        "Pick the method for this problem:",
        context,
        "Choose the method that best fits."
      ),
      back: `Method: ${methodText}`,
      tags: ["method"],
    });
  }

  suggestions.push({
    id: "trigger",
    type: "trigger_cloze",
    front: formatFront(
      "What clue tells you the method?",
      context,
      "Name the pattern that points to the method."
    ),
    back: (() => {
      if (whyShort && methodText) return `Clue: ${whyShort}\nMethod: ${methodText}`;
      if (whyShort) return `Clue: ${whyShort}`;
      if (methodText) return `Method: ${methodText}`;
      return "Name the pattern and the method.";
    })(),
    tags: ["trigger"],
  });

  if (trapShort) {
    suggestions.push({
      id: "common-trap",
      type: "common_trap",
      front: formatFront(
        "Common trap to avoid:",
        context,
        "Recall a pitfall to avoid."
      ),
      back: `Avoid: ${trapShort}`,
      tags: ["trap"],
    });
  }

  return suggestions.filter((item) => item.front && item.back).slice(0, 3);
};

export default buildFlashcardSuggestions;
